import {
  UsCbpDrawbackClaimStatus,
  WorkOrderMilestoneName,
  WorkOrderStatus,
} from '@xbcb/work-order-types';
import type { UsDrawbackClaim } from '@xbcb/api-gateway-client';
import { isRecordCanceled, isRecordReplaced } from 'libs/workOrderConditions';

export const isClaimWithCbp = (record: Partial<UsDrawbackClaim>): boolean =>
  record.cbpStatus === UsCbpDrawbackClaimStatus.SUBMITTED ||
  record.cbpStatus === UsCbpDrawbackClaimStatus.FILED;

export const isClaimRejectedByCbp = (
  record: Partial<UsDrawbackClaim>,
): boolean => record.cbpStatus === UsCbpDrawbackClaimStatus.REJECTED;

export const wasClaimFiledWithCbp = (
  record: Partial<UsDrawbackClaim> | undefined,
): boolean =>
  (record?.milestones ?? []).some(
    (milestone) => milestone?.name === WorkOrderMilestoneName.US_DRAWBACK_FILED,
  );

export const isClaimLocked = (
  record: Partial<UsDrawbackClaim> | undefined,
): boolean => {
  if (!record) return false;
  return (
    isRecordCanceled(record) ||
    isRecordReplaced(record) ||
    (record.status === WorkOrderStatus.COMPLETED &&
      !isClaimRejectedByCbp(record)) ||
    isClaimWithCbp(record)
  );
};
